import { ReactNode } from 'react';

import { ThemeProvider } from '@material-ui/core';

import {
  encoreDarkTheme,
  encoreLightTheme,
} from '@spotify/confidence-backstage-encore-theme';

import { useBUITheme } from './useBUITheme';

export const EncoreDarkThemeProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  useBUITheme('dark');

  return <ThemeProvider theme={encoreDarkTheme}>{children}</ThemeProvider>;
};

export const EncoreLightThemeProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  useBUITheme('light');

  return <ThemeProvider theme={encoreLightTheme}>{children}</ThemeProvider>;
};
